// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.masterForm-container {
  max-width: 450px;
  margin: 40px auto;
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}

.Master-form-title {
  text-align: center;
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #333;
}

.masterForm {
  display: flex;
  flex-direction: column;
}

.master-form-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
}

.master-form-group label {
  font-size: 14px;
  font-weight: 600;
  color: #555;
  margin-bottom: 5px;
}

.master-form-group input {
  padding: 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 5px;
  transition: border 0.3s ease;
}

.master-form-group input:focus {
  border-color: #007bff;
  outline: none;
}

.master-submit-btn {
  width: 100%;
  padding: 12px;
  font-size: 16px;
  font-weight: bold;
  color: white;
  background-color: #007bff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.master-submit-btn:hover {
  background-color: #0056b3;
}

@media (max-width: 600px) {
  .masterForm-container {
    max-width: 90%;
    padding: 15px;
  }

  .Master-form-title {
    font-size: 20px;
  }

  .master-form-group input {
    font-size: 13px;
    padding: 8px;
  }

  .master-submit-btn {
    padding: 10px;
    font-size: 14px;
  }
}

.star-rating {
  display: flex;
  gap: 5px;
  font-size: 24px;
  cursor: pointer;
}

.star {
  color: #ccc;
  transition: color 0.3s;
}

.star.selected {
  color: gold;
}

.master-list-container {
  width: 100%;
  margin: 20px auto;
  padding: 15px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  overflow-x: auto;
}

.master-list-title {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 15px;
}

.mater_table_responsive {
  overflow-x: auto;
  width: 100%;
}

.master_table {
  width: 100%;
  border-collapse: collapse;
}

.master_table th,
.master_table td {
  padding: 10px;
  text-align: left;
  border: 1px solid #ddd;
}

.master_table th {
  background: #007bff;
  color: #fff;
  font-weight: bold;
}

.master_table tr:nth-child(even) {
  background: #f8f9fa;
}

.master_table tr:hover {
  background: #e9ecef;
}

@media screen and (max-width: 768px) {
  .master_table {
    width: 100%;
    display: block;
    overflow-x: auto;
  }

  .master_table thead {
    display: none;
  }

  .master_table tr {
    display: block;
    margin-bottom: 10px;
    border: 1px solid #ddd;
    padding: 10px;
    background: #fff;
  }

  .master_table td {
    display: block;
    text-align: right;
    font-size: 14px;
    padding: 8px;
    position: relative;
  }

  .master_table td::before {
    content: attr(data-label);
    position: absolute;
    left: 10px;
    font-weight: bold;
    text-align: left;
  }
}
.delete_master_button {
  background: #dc3545;
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 5px;
  cursor: pointer;
  transition: background 0.3s ease;  
}
/* Search & Filter Styles */
.master-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 20px;
  gap: 16px;
}

.master-search-input {
  padding: 10px 16px;
  font-size: 1rem;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  width: 320px;
  max-width: 100%;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.master-search-input:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
}

.no-results {
  text-align: center;
  padding: 60px 20px;
  background: #f9fafb;
  border-radius: 12px;
  color: #6b7280;
  font-size: 1.1rem;
}

.clear-search-btn {
  margin-top: 16px;
  padding: 10px 24px;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
}

.clear-search-btn:hover {
  background: #2563eb;
}`, "",{"version":3,"sources":["webpack://./src/styles/Addmaster.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;IACX,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,gBAAgB;EAClB;AACF;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;AACA,2BAA2B;AAC3B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".masterForm-container {\n  max-width: 450px;\n  margin: 40px auto;\n  padding: 20px;\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n}\n\n.Master-form-title {\n  text-align: center;\n  font-size: 22px;\n  font-weight: bold;\n  margin-bottom: 20px;\n  color: #333;\n}\n\n.masterForm {\n  display: flex;\n  flex-direction: column;\n}\n\n.master-form-group {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 15px;\n}\n\n.master-form-group label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #555;\n  margin-bottom: 5px;\n}\n\n.master-form-group input {\n  padding: 10px;\n  font-size: 14px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  transition: border 0.3s ease;\n}\n\n.master-form-group input:focus {\n  border-color: #007bff;\n  outline: none;\n}\n\n.master-submit-btn {\n  width: 100%;\n  padding: 12px;\n  font-size: 16px;\n  font-weight: bold;\n  color: white;\n  background-color: #007bff;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background 0.3s ease;\n}\n\n.master-submit-btn:hover {\n  background-color: #0056b3;\n}\n\n@media (max-width: 600px) {\n  .masterForm-container {\n    max-width: 90%;\n    padding: 15px;\n  }\n\n  .Master-form-title {\n    font-size: 20px;\n  }\n\n  .master-form-group input {\n    font-size: 13px;\n    padding: 8px;\n  }\n\n  .master-submit-btn {\n    padding: 10px;\n    font-size: 14px;\n  }\n}\n\n.star-rating {\n  display: flex;\n  gap: 5px;\n  font-size: 24px;\n  cursor: pointer;\n}\n\n.star {\n  color: #ccc;\n  transition: color 0.3s;\n}\n\n.star.selected {\n  color: gold;\n}\n\n.master-list-container {\n  width: 100%;\n  margin: 20px auto;\n  padding: 15px;\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  overflow-x: auto;\n}\n\n.master-list-title {\n  text-align: center;\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: 15px;\n}\n\n.mater_table_responsive {\n  overflow-x: auto;\n  width: 100%;\n}\n\n.master_table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.master_table th,\n.master_table td {\n  padding: 10px;\n  text-align: left;\n  border: 1px solid #ddd;\n}\n\n.master_table th {\n  background: #007bff;\n  color: #fff;\n  font-weight: bold;\n}\n\n.master_table tr:nth-child(even) {\n  background: #f8f9fa;\n}\n\n.master_table tr:hover {\n  background: #e9ecef;\n}\n\n@media screen and (max-width: 768px) {\n  .master_table {\n    width: 100%;\n    display: block;\n    overflow-x: auto;\n  }\n\n  .master_table thead {\n    display: none;\n  }\n\n  .master_table tr {\n    display: block;\n    margin-bottom: 10px;\n    border: 1px solid #ddd;\n    padding: 10px;\n    background: #fff;\n  }\n\n  .master_table td {\n    display: block;\n    text-align: right;\n    font-size: 14px;\n    padding: 8px;\n    position: relative;\n  }\n\n  .master_table td::before {\n    content: attr(data-label);\n    position: absolute;\n    left: 10px;\n    font-weight: bold;\n    text-align: left;\n  }\n}\n.delete_master_button {\n  background: #dc3545;\n  color: white;\n  border: none;\n  padding: 5px 10px;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background 0.3s ease;  \n}\n/* Search & Filter Styles */\n.master-list-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  margin-bottom: 20px;\n  gap: 16px;\n}\n\n.master-search-input {\n  padding: 10px 16px;\n  font-size: 1rem;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  width: 320px;\n  max-width: 100%;\n  outline: none;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.master-search-input:focus {\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);\n}\n\n.no-results {\n  text-align: center;\n  padding: 60px 20px;\n  background: #f9fafb;\n  border-radius: 12px;\n  color: #6b7280;\n  font-size: 1.1rem;\n}\n\n.clear-search-btn {\n  margin-top: 16px;\n  padding: 10px 24px;\n  background: #3b82f6;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 1rem;\n}\n\n.clear-search-btn:hover {\n  background: #2563eb;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
